module.exports = __webpack_public_path__ + "img/zyrianov.559578aa.jpg";